import {
  format,
  isSameYear,
  fromUnixTime,
  formatDistanceToNow,
} from 'date-fns';
import { getDateFnsLocale } from 'dashboard/helper/dateFnsLocaleHelper';

export default {
  methods: {
    messageStamp(time, dateFormat = 'h:mm a') {
      const unixTime = fromUnixTime(time);
      return format(unixTime, dateFormat);
    },
    messageTimestamp(time, dateFormat = 'MMM d, yyyy') {
      const messageTime = fromUnixTime(time);
      const now = new Date();
      const messageDate = format(messageTime, dateFormat);
      if (!isSameYear(messageTime, now)) {
        return format(messageTime, 'LLL d y, h:mm a');
      }
      return messageDate;
    },
    dynamicTime(time) {
      const unixTime = fromUnixTime(time);
      const locale = getDateFnsLocale(this.$i18n?.locale);
      return formatDistanceToNow(unixTime, { addSuffix: true, locale });
    },
    dateFormat(time, dateFormat = 'MMM d, yyyy') {
      const unixTime = fromUnixTime(time);
      return format(unixTime, dateFormat);
    },
    shortTimestamp(time, withAgo = false) {
      const t = key => this.$t?.(key);
      const now = t('CHAT_LIST.SHORT_TIMESTAMP.NOW') ?? 'now';
      const suffix = withAgo
        ? (t('CHAT_LIST.SHORT_TIMESTAMP.SUFFIX.AGO') ?? ' ago')
        : '';
      const units = {
        m: t('CHAT_LIST.SHORT_TIMESTAMP.UNITS.MINUTE') ?? 'm',
        h: t('CHAT_LIST.SHORT_TIMESTAMP.UNITS.HOUR') ?? 'h',
        d: t('CHAT_LIST.SHORT_TIMESTAMP.UNITS.DAY') ?? 'd',
        mo: t('CHAT_LIST.SHORT_TIMESTAMP.UNITS.MONTH') ?? 'mo',
        y: t('CHAT_LIST.SHORT_TIMESTAMP.UNITS.YEAR') ?? 'y',
      };

      const timeDiff = Math.floor(Date.now() / 1000 - time);

      if (timeDiff < 60) return now;

      const minutes = Math.floor(timeDiff / 60);
      if (minutes < 60) return `${minutes}${units.m}${suffix}`;

      const hours = Math.floor(timeDiff / 3600);
      if (hours < 24) return `${hours}${units.h}${suffix}`;

      const days = Math.floor(timeDiff / 86400);
      if (days < 30) return `${days}${units.d}${suffix}`;

      const months = Math.floor(timeDiff / (86400 * 30));
      if (months < 12) return `${months}${units.mo}${suffix}`;

      const years = Math.floor(timeDiff / (86400 * 365));
      return `${years}${units.y}${suffix}`;
    },
  },
};
